'use strict'

/**
 * Project janux-vuejs-seed
 * Created by hielo on 2018-04-18
 *
 * This can be imported in any service or used through a plugin
 */

import _ from 'lodash'

export function jsonrpc (http, progressIndicatorReference) {
	return (url, method, parameters, config) => {
		// Check if we have progress component defined
		if (!_.isNil(progressIndicatorReference)) {
			progressIndicatorReference.start()
		}

		// Custom headers
		const headers = {
			'Content-Type': 'application/json;charset=utf-8'
		}

		// Data to be sent as the request body
		const data = { 'jsonrpc': '2.0', 'method': method, 'params': parameters, 'id': 1 }

		// filter the user object from the logs, more cosmetic than security issue
		var filteredParms = _.filter(parameters, (parm) => {
			return !_.isString(parm.password)
		})
		console.debug('calling:' + url + ' - ' + method + ' - ' + JSON.stringify(filteredParms))

		return http.post(url, data, {'headers': headers}).then((response) => {
			// console.debug('jsonrpc url:', url, ' method:', method, 'response:', response.body)
			console.debug('jsonrpc url:', url, ' method:', method, 'response:', response.body)
			if (!_.isNil(progressIndicatorReference)) {
				progressIndicatorReference.finish()
			}
			console.debug('post response body ', response.body)
			return response.body
		})
	}
}



// WEBPACK FOOTER //
// ../easytitle24-2.x-common/jsonrpc.js